<template>
  <div>
    <v-card
      tile
      width="100%"
      class="footer-div lighten-1 text-center"
      color="#f5f5f5"
    >
      <v-card-title
        >{{ reviewer.Email }} <v-spacer></v-spacer>
        <v-chip :color="reviewer.Status == 'active' ? 'green' : 'orange'">{{
          reviewer.Status
        }}</v-chip>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="d-flex justify-left">
            <h4>Linkedin profile:</h4>
            <a :href="reviewer.LinkedinUrl" target="_blank" class="ml-1">
              {{ reviewer.LinkedinUrl }}
            </a>
          </v-col>
          <v-col cols="4" class="d-flex justify-left ma-0 pa-0 ml-2">
            <v-checkbox
              v-model="reviewer.NeedsVerification"
              label="Needs verification"
            >
            </v-checkbox>
          </v-col>
          <v-col cols="4">
            <v-combobox
              label="Reviewer status"
              :items="['active', 'inactive']"
              v-model="reviewer.Status"
            >
            </v-combobox>
          </v-col>
          <v-col cols="12">
            <v-select
              v-model="reviewer.Companies"
              :items="availableCompanies"
              :item-text="(item) => item.Name + ' (' + item.Id + ')'"
              item-value="Id"
              attach
              chips
              label="Companies reviewer is allowed to review"
              multiple
            ></v-select>
          </v-col>
          <v-col cols="12" v-if="getCompaniesError != ''">
            <v-alert dense outlined text type="error" class="ma-0">
              {{ getCompaniesError }}
            </v-alert>
          </v-col>
          <v-col cols="12">
            {{ reviewer.Companies }}
          </v-col>
          <v-col cols="12" class="d-flex ma-0 pa-0">
            <h4>Experience:</h4>
            <v-spacer></v-spacer>
            <v-checkbox
              v-model="editMode"
              label="edit mode"
              class="ma-0 pa-0 mr-3"
            ></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-card v-for="exp in experienceArr" :key="exp.id" class="mb-7">
              <v-row>
                <v-col cols="12" class="d-flex justify-left ml-2 pb-0">
                  <v-chip v-if="exp.selCompany" small>{{
                    exp.selCompany.Name
                  }}</v-chip>
                  <h4 v-if="!exp.selCompany">
                    -- NOT EXISTING COMPANY -- ({{ exp.manualCompanyName }})
                  </h4>
                  <p class="ml-2">
                    ({{ exp.startDate }} -
                    {{ exp.isCurrent ? "now" : exp.endDate }})
                  </p>
                  <p class="ml-2">{{ exp.selRoles }})</p>
                  <v-spacer></v-spacer>
                  <v-checkbox
                    v-model="exp.isVerified"
                    label="experience verified"
                    class="ma-0 pa-0 mr-4"
                  >
                  </v-checkbox>
                </v-col>
                <v-col v-if="editMode" cols="4">
                  <v-combobox
                    v-model="exp.selCompany"
                    :items="availableCompanies"
                    label="Sel company"
                    :item-text="(item) => item.Name + ' (' + item.Id + ')'"
                  >
                  </v-combobox>
                </v-col>
                <v-col v-if="editMode" cols="4">
                  <v-text-field
                    v-model="exp.manualCompanyName"
                    label="Manual company name"
                    clearable
                  >
                  </v-text-field>
                </v-col>
                <v-col v-if="editMode" cols="4">
                  <v-text-field
                    v-model="exp.manualCompanyWebsite"
                    label="Manual company website"
                    prefix="https://"
                    clearable
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" v-if="!exp.selCompany">
                  <v-btn @click="openAddNewCompanyDialog(exp)" color="orange">
                    Add company
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="saveUpdatesError != ''" class="ma-0 pa-0">
          <v-col>
            <v-alert dense outlined text type="error" class="ma-0">
              {{ saveUpdatesError }}
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="updateReviewer()"
          :loading="saveUpdatesLoading"
        >
          Save updates
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="addCompanyDialog" max-width="700">
      <v-card>
        <v-card-title class="text-h5"> Add new company </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Company ID (4 lowercase letters)"
                v-model="addCompanyId"
              >
              </v-text-field>
              <v-text-field label="Company name" v-model="addCompanyName">
              </v-text-field>
              <v-text-field
                label="Company website"
                v-model="addCompanyWebsite"
                prefix="https://"
              >
              </v-text-field>
              <v-text-field
                label="(optional) Company logo url"
                v-model="addCompanyLogo"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" class="ma-0 pa-0" v-if="addCompanyError != ''">
              <v-alert dense outlined text type="error" class="ma-0">
                {{ addCompanyError }}
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="closeNewCompanyDialog()">
            Cancel
          </v-btn>
          <v-btn color="green darken-1" text @click="saveNewCompany()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["reviewer"],
  data() {
    return {
      experienceArr: [],
      availableCompanies: [],
      getCompaniesError: "",
      editMode: false,
      saveUpdatesLoading: false,
      saveUpdatesError: "",
      addCompanyDialog: false,
      // this is just to track which experience are we adding a new company for
      addCompanyExperienceArrId: -1,
      addCompanyId: "",
      addCompanyName: "",
      addCompanyWebsite: "",
      addCompanyLogo: "",
      addCompanyError: "",
    };
  },
  mounted() {
    this.parseExperience();
    this.getAvailableCompanies();
    reviewer.cop;
  },
  methods: {
    parseExperience() {
      // todo: fix this mess... We parse experience because we store it in db as json which is lazy and not great.
      if (this.reviewer) {
        this.experienceArr = JSON.parse(this.reviewer.Experience);
      }
    },
    async getAvailableCompanies() {
      this.getCompaniesError = "";
      try {
        var resp = await this.$utils.callBackendPost(
          this,
          "/pub/getAllCompanies"
        );
        this.availableCompanies = resp;
      } catch (error) {
        this.getCompaniesError = error;
      }
    },
    // new company dialog stuff
    closeNewCompanyDialog() {
      this.addCompanyDialog = false;
      this.addCompanyExperienceArrId = -1;
      this.addCompanyId = "";
      this.addCompanyName = "";
      this.addCompanyWebsite = "";
      this.addCompanyLogo = "";
    },
    async saveNewCompany(expArrId) {
      try {
        this.addCompanyError = "";
        await this.$utils.callBackendPost(this, "/admin/addNewCompany", {
          companyId: this.addCompanyId,
          companyName: this.addCompanyName,
          companyWebsite: "https://" + this.addCompanyWebsite,
          companyLogo: this.addCompanyLogo,
        });
        // refresh selCompany comboboxes source
        await this.getAvailableCompanies();
        // switch current exp to new company
        var comp = this.availableCompanies.find(
          (c) => c.Id === this.addCompanyId
        );
        if (comp) {
          for (var i = 0; i < this.experienceArr.length; i++) {
            if (this.experienceArr[i].Id === this.addCompanyExperienceArrId) {
              this.experienceArr[i].selCompany = comp;
              this.experienceArr[i].manualCompanyName = "";
              this.experienceArr[i].manualCompanyWebsite = "";
            }
          }
        }
      } catch (error) {
        this.addCompanyError = error;
        return;
      } finally {
        this.closeNewCompanyDialog();
      }
    },
    openAddNewCompanyDialog(exp) {
      this.addCompanyExperienceArrId = exp.Id;
      this.addCompanyError = "";
      this.addCompanyId = "";
      this.addCompanyName = exp.manualCompanyName;
      this.addCompanyWebsite = exp.manualCompanyWebsite;
      this.addCompanyLogo = "";
      this.addCompanyDialog = true;
    },
    async updateReviewer() {
      // transfer experienceArr back to reviewer
      this.reviewer.Experience = JSON.stringify(this.experienceArr);
      // warn if status is not set to active
      if (
        this.reviewer.Status !== "active" &&
        !confirm(
          "User status is not active. Are you sure you want to save this?"
        )
      ) {
        return;
      }
      try {
        this.saveUpdatesLoading = true;
        this.saveUpdatesError = "";
        await this.$utils.callBackendPost(
          this,
          "/admin/updateReviewer",
          this.reviewer
        );
      } catch (error) {
        this.saveUpdatesError = error;
      } finally {
        this.saveUpdatesLoading = false;
      }
    },
  },
};
</script>

<style scoped></style>
